// Gets the name of this script in order to get parameters...

// Does not work in IE11, polyfill required
export default function getCurrentScriptSrc (): string {
  return getImportMetaUrl() ?? getDocumentCurrentScript() ?? getLastScript()
}

/**
 * Gets the URL of the current script, if available from import.meta.url
 *
 * @returns {string | undefined}
 */
export function getImportMetaUrl (): string | undefined {
  try {
    // If in a module context, this will not throw
    return import.meta.url
  } catch (error) {
    // Not in a module context or other error occurred
    return undefined
  }
}

/**
 * Gets the URL of the current script, if available from document.currentScript
 *
 * @returns {string | undefined}
 */
export function getDocumentCurrentScript (): string | undefined {
  if ((document.currentScript != null) && document.currentScript instanceof HTMLScriptElement) {
    return document.currentScript.src
  }
  // else
  return undefined
}

/**
 * Gets the URL of the last script in the document
 *
 * Note: this is not guaranteed to be the current script
 *
 * @returns {string}
 */
export function getLastScript (): string {
  const scripts = window.document.getElementsByTagName('script')
  return scripts[scripts.length - 1].src
}
